<template>
    <div>
        <app-header :isDashboard="isDashboard"  :isProject="isProject" :projectTitle="projectTitle" :username="username"></app-header>

        <transition name="fade" mode="out-in">
            <router-view :key="$route.path"></router-view>
        </transition>
    </div>
</template>

<script>
import Header from "./Header.vue";
import { getProj, getAuth } from "../helpers/index";
import AuthMiddleware from './mixin/AuthMiddleware'

export default {
  mixins: [AuthMiddleware],
  components: {
    appHeader: Header
  },
  data() {
    return {
      isDashboard: true,
      projectTitle: "",
      username: "",
      isProject: false
    }
  },
  mounted() {

    this.updateTitle();
  },
  updated() {

    this.updateTitle();
  },
  methods: {
    updateTitle() {

      this.projectTitle = getProj().projName;
      this.username = getAuth().name;
        
      if(!this.projectTitle)
        this.$router.push({ name: "projectSelection" })
    }
  }
};
</script>